import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerClearTurnoverHistory } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import type {
	GetPlayerClearTurnoverHistoryRequest,
	GetPlayerClearTurnoverHistoryResponse,
} from '../../../type'

export default function useQueryClearTurnoverHistory(
	payload: GetPlayerClearTurnoverHistoryRequest,
	props?: UseBaseQueryOptions<GetPlayerClearTurnoverHistoryResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.ClearTurnoverHistory, payload],
		queryFn: () => getPlayerClearTurnoverHistory(payload),
		...props,
	})
}
